import store from "@/store"

export default {
  data() {
    return {
      uploadImageParam: {
        folder: 'cover',
        type: 'image'
      },
      uploadVideoParam: {
        folder: 'video',
        type: 'video'
      },
      uploadPdfParam: {
        folder: 'instructions',
        type: 'pdf'
      },
      imageAccept: ".jpg,.jpeg,.png,.gif,.svg",
      videoAccept: ".mp4",
      pdfAccept: ".pdf"
    }
  },
  computed: {
    uploadPath() {
      return this.$config.api.baseURL + '/upload'
    },

    uploadHeaders() {
      const { token } = store.state.auth
      return {
        'Authorization': `Bearer ${token}`
      }
    },
  },

  methods: {
    beforePdfUpload(file) {
      const isLt = file.size / 1024 / 1024 <= 50
      if(!isLt) {
        this.$message.warning("文件大小不能超过50M")
        return false
      }
      this.loading = true
    },
    beforeImageUpload(file) {
      const isLt4M = file.size / 1024 / 1024 <= 50
      if(!isLt4M) {
        this.$message.warning("图片大小不能超过50M")
        return false
      }
      this.loading = true
    },
  },
}